import 'slick-carousel';
import BreakpointsEnum from "./enums/breakpointsEnum";
import initSlickSliderObserver from "./observers/lazyLoading";
import {popularCategorySliderOptions} from "./common/sliderOptions";

require('./components/product');

let subCategoriesSlider = document.getElementById('categoriesSlider');

if ($('.tags-container .slider').length) {
    require('./components/tags-slider');
}

$(function() {
    initSlickSliderObserver(subCategoriesSlider, popularCategorySliderOptions);
});

$(window).on('load resize', () => {
    if ([BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop].includes(window.App.getBreakpoint())) {
        initSlickSliderObserver(subCategoriesSlider, popularCategorySliderOptions);
    }
});
